import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { ConceptBadge } from '@bwoty-web/ui-kit';
import './uspList.scss';

const UspList = ({ usps = [], isConceptHotel, concept = null, labels }) => {
  if (usps.length < 1) {
    return null;
  }

  const conceptName =
    concept?.name?.split('.')?.join('')?.split(' ')?.join('') || '';

  return (
    <div className={`gw-hotel-usps gw-hotel-usps--${conceptName}`}>
      {isConceptHotel && !!concept && (
        <div className="gw-hotel-usps__concept-header">
          <ConceptBadge
            className="gw-hotel-usps__concept-badge"
            concept={conceptName}
          />
          <div className="gw-hotel-usps__concept-description">
            {concept?.description}
          </div>
        </div>
      )}
      {!isConceptHotel && (
        <h3 className="gw-hotel-usps__heading">{labels.uspListHeading}</h3>
      )}
      <ul className="gw-hotel-usps__list">
        {usps.map((usp) => {
          return <li key={uniqid('usp-list-item-')}>{usp}</li>;
        })}
      </ul>
    </div>
  );
};

UspList.propTypes = {
  usps: PropTypes.arrayOf(PropTypes.string).isRequired,
  isConceptHotel: PropTypes.bool.isRequired,
  concept: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  labels: PropTypes.shape({
    uspListHeading: PropTypes.string,
  }).isRequired,
};

export default UspList;
